import headshotImg from '../../assets/headshot.jpg';
import githubLogo from '../../assets/GitHub-Mark-32px.png';
import linkedinLogo from '../../assets/In-2C-41px-R.png';
import styles from './About.module.css';

function About() {
  return (
    <article id="about">
      <div id="headshot-holder" className={styles.headshotHolder}>
        <img id="headshot" className={styles.headshot} src={headshotImg} alt="Linus headshot" />
      </div>

      <div id="about-text" className={`body-text ${styles.aboutText}`}>
        <p>
          I am a Managing Director and Principal Software Engineer at Wellington Management in Boston.
          I lead a team of engineers building applications, tools, and platforms that help investors
          understand, monitor, and interact with their data. I have extensive experience in cloud
          architecture, full-stack software development, data engineering, and data visualization.
        </p>

        <p>
          Outside of programming, I'm a cyclist and a huge baseball fan with a strong interest in
          sabermetrics and analytics.
        </p>
      </div>

      <div className={`${styles.socialSwatch} ${styles.githubSwatch}`}>
        <a className="evergreen" href="https://www.github.com/linusmarco" target="_blank" rel="noopener noreferrer">
          <img src={githubLogo} alt="GitHub logo" />
        </a>
        <a className="evergreen" href="https://www.linkedin.com/in/linusmarco" target="_blank" rel="noopener noreferrer">
          <img src={linkedinLogo} alt="LinkedIn logo" />
        </a>
      </div>
    </article>
  );
}

export default About;
